import { render, staticRenderFns } from "./CoEvaluatorSelectedInput.vue?vue&type=template&id=477f0104&scoped=true"
import script from "./CoEvaluatorSelectedInput.vue?vue&type=script&lang=js"
export * from "./CoEvaluatorSelectedInput.vue?vue&type=script&lang=js"
import style0 from "./CoEvaluatorSelectedInput.vue?vue&type=style&index=0&id=477f0104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f0104",
  null
  
)

export default component.exports